import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { controlApi } from 'api';
import { ContainerFluid } from 'common/styles';
import { Loader } from 'modules/core/components';
import { SSO_TYPE } from 'modules/core/constants';
import { Header } from 'modules/core/components/Header/Header';
import { DealSourceProvider } from 'modules/core/enums';
import { RouteOneMaintenance } from 'pages/ErrorPage/components';
import { getUser } from 'store/selectors/auth.selector';

export const RouteOneMaintenanceGate: FC = ({ children }) => {
  const user = useSelector(getUser);
  const isRouteOneLenderSso =
    !!user?.is_sso && user.sso_type === SSO_TYPE.LENDER && user.dealSource === DealSourceProvider.ROUTE_ONE;
  const [isMaintenance, setIsMaintenance] = useState<boolean>();

  useEffect(() => {
    if (!isRouteOneLenderSso) return;

    controlApi
      .getRouteOneMaintenance()
      .then(({ data }) => setIsMaintenance(data.enabled))
      .catch(() => setIsMaintenance(false));
  }, [isRouteOneLenderSso]);

  if (!isRouteOneLenderSso) return <>{children}</>;

  if (isMaintenance === undefined) return <Loader />;

  return isMaintenance ? (
    <ContainerFluid fluid>
      <Header withoutSideBar />
      <RouteOneMaintenance />
    </ContainerFluid>
  ) : (
    <>{children}</>
  );
};
